import React from 'react';
import AppListToolbarGlobal, { type CompanyOption } from '@/__core/components/AppLisstToolbarGlobal';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  CheckCircle as ApproveIcon,
  Delete as DeleteIcon,
  DeleteOutline as TrashIcon,
} from '@mui/icons-material';
import Badge from '@mui/material/Badge';
import { sharedToolbarListStyles } from '@/__core/styles';

export interface TransactionsToolbarGlobalProps {
  /** @deprecated Chỉ dùng khi test; mặc định lấy từ auth + resolveModuleAccessibleCompanies */
  companies?: CompanyOption[];
  fetchCompanies?: () => Promise<CompanyOption[]>;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  onSearchSubmit?: () => void;
  onToggleAdvancedSearch?: () => void;
  isAdvancedSearchOpen?: boolean;
  onFilterChange?: (field: string, value: string) => void;

  filters?: {
    company: string;
  };
  advancedPanel?: React.ReactNode;
  advancedPanelOwnCollapse?: boolean;
  rightSection?: React.ReactNode;
  selectedCount?: number;
  onDelete?: () => void;
  onApprove?: () => void;
  onRefresh?: () => void;
  onOpenTrash?: () => void;
  onApplyFilters?: () => void;
  deletedItemsCount?: number;
  canApprove?: boolean;
  canDelete?: boolean;
}

export default function TransactionsToolbarGlobal({
  companies,
  searchQuery = '',
  onSearchChange,
  onSearchSubmit,
  onToggleAdvancedSearch,
  isAdvancedSearchOpen = false,
  filters = { company: 'all' },
  onFilterChange,
  advancedPanel,
  advancedPanelOwnCollapse = true,
  rightSection,
  selectedCount = 0,
  onDelete,
  onApprove,
  onRefresh,
  onOpenTrash,
  deletedItemsCount = 0,
  canApprove = false,
  canDelete = false,
}: TransactionsToolbarGlobalProps) {
  const rightActions = (
    <>
      {selectedCount > 0 && canApprove && onApprove && (
        <Tooltip title={`Duyệt (${selectedCount})`} arrow>
          <IconButton
            onClick={onApprove}
            size='small'
            sx={{
              ...sharedToolbarListStyles.actionIconButtonBase,
              borderColor: '#10b981',
              color: '#10b981',
              '&:hover': { borderColor: '#059669', backgroundColor: '#ecfdf5' },
            }}
          >
            <ApproveIcon sx={sharedToolbarListStyles.toolbarActionIcon} />
          </IconButton>
        </Tooltip>
      )}
      {selectedCount > 0 && canDelete && onDelete && (
        <Tooltip title={`Xóa (${selectedCount})`} arrow>
          <IconButton
            onClick={onDelete}
            size='small'
            sx={{
              ...sharedToolbarListStyles.actionIconButtonBase,
              ...sharedToolbarListStyles.deleteIconButton,
            }}
          >
            <Badge badgeContent={selectedCount} color='error' max={99}>
              <DeleteIcon sx={sharedToolbarListStyles.toolbarActionIcon} />
            </Badge>
          </IconButton>
        </Tooltip>
      )}
      {canDelete && onOpenTrash && (
        <Tooltip title='Thùng rác' arrow>
          <IconButton
            onClick={onOpenTrash}
            size='small'
            sx={{
              ...sharedToolbarListStyles.actionIconButtonBase,
              ...sharedToolbarListStyles.trashIconButton,
            }}
          >
            <Badge badgeContent={deletedItemsCount} color='error' max={120}>
              <TrashIcon sx={sharedToolbarListStyles.toolbarActionIcon} />
            </Badge>
          </IconButton>
        </Tooltip>
      )}
     
    </>
  );

  return (
    <AppListToolbarGlobal
      scopeModule='transactions'
      companies={companies}
      searchPlaceholder='Tìm kiếm thu chi...'
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      onSearchSubmit={onSearchSubmit}
      isAdvancedSearchOpen={isAdvancedSearchOpen}
      onToggleAdvancedSearch={onToggleAdvancedSearch}
      selectedCompany={filters.company}
      onCompanyChange={(id) => onFilterChange?.('company', id)}
      advancedFilterFields={[]}
      advancedPanel={advancedPanel}
      advancedPanelOwnCollapse={advancedPanelOwnCollapse}
      rightSection={rightSection}
      rightActions={rightActions}
    />
  );
}

